export default __webpack_public_path__ + "static/media/ASEAN-green-bond-standard.4bf849d8.jpg";